import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import AuthorDashboard from './components/AuthorDashboard';
import StudentDashboard from './components/StudentDashboard';
import CourseView from './components/CourseView';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import api from './services/api';

function AppContent() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          user.role === 'admin' ? (
            <Navigate to="/admin" replace />
          ) : user.role === 'author' ? (
            <Navigate to="/author" replace />
          ) : (
            <Navigate to="/student" replace />
          )
        }
      />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/author" element={<AuthorDashboard />} />
      <Route path="/student" element={<StudentDashboard />} />
      <Route path="/course/:id" element={<CourseView />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
